import { ApiProvider, createQueryClient } from '@fidalia/api';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { apiClient, tokenStore } from '@/lib/api';
import { initAnalytics, trackPageView } from '@/lib/analytics';
import '@/lib/dayjs';
import { routeTree } from './routeTree.gen';
import './styles.css';

const queryClient = createQueryClient();

const router = createRouter({
  routeTree,
  context: { queryClient, tokens: tokenStore, api: apiClient },
  defaultPreload: 'intent',
  scrollRestoration: true,
  // Avec un bandeau, le contenu défile dans la coquille et non dans la fenêtre.
  scrollToTopSelectors: ['[data-scroll-root]'],
});

initAnalytics();
// Chaque changement de route est une vue : l'app est monopage, le navigateur
// ne recharge rien.
router.subscribe('onResolved', ({ toLocation }) => trackPageView(toLocation.pathname));

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }

  interface HistoryState {
    /**
     * Ticket d'inscription signé, transmis du retour OAuth au formulaire.
     * Passe par l'état d'historique plutôt que par l'URL : il ne s'affiche
     * nulle part et ne peut pas être copié par mégarde.
     */
    ticketGoogle?: string;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('#root introuvable');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ApiProvider client={apiClient}>
        <RouterProvider router={router} />
      </ApiProvider>
    </QueryClientProvider>
  </StrictMode>,
);
